import { render, staticRenderFns } from "./MarksModal.vue?vue&type=template&id=37a0e29c&"
import script from "./MarksModal.vue?vue&type=script&lang=js&"
export * from "./MarksModal.vue?vue&type=script&lang=js&"
import style0 from "./MarksModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports